class CatalogsCache {
  __cached = {}

  static _instances = {};

  put(name, value) {
    if (!this.__cached[name]) {
      this.__cached[name] = []
    }

    this.__cached[name] = [].concat(this.__cached[name], value);
  }

  get(name) {
    return this.__cached[name];
  }

  delete(name) {
    delete this.__cached[name];
  }

  flush() {
    this.__cached = {};
  }

  all() {
    return this.__cached;
  }

  static instance(name = 'defaul') {
    if (!CatalogsCache._instances[name]) {
      CatalogsCache._instances[name] = new CatalogsCache();
    }

    return CatalogsCache._instances[name];
  }
}

export default CatalogsCache;